import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessTimeline = ({ steps, theme = 'default' }) => {
  const getThemeClasses = () => {
    switch (theme) {
      case 'events':
        return {
          line: 'bg-rose-200',
          activeLine: 'bg-rose-600',
          activeStep: 'bg-rose-600 border-rose-600',
          inactiveStep: 'bg-white border-rose-200',
          activeText: 'text-rose-600',
          activeIcon: 'text-white'
        };
      case 'realestate':
        return {
          line: 'bg-blue-200',
          activeLine: 'bg-blue-600',
          activeStep: 'bg-blue-600 border-blue-600',
          inactiveStep: 'bg-white border-blue-200',
          activeText: 'text-blue-600',
          activeIcon: 'text-white'
        };
      case 'marketing':
        return {
          line: 'bg-orange-200',
          activeLine: 'bg-orange-600',
          activeStep: 'bg-orange-600 border-orange-600',
          inactiveStep: 'bg-white border-orange-200',
          activeText: 'text-orange-600',
          activeIcon: 'text-white'
        };
      case 'design':
        return {
          line: 'bg-emerald-200',
          activeLine: 'bg-emerald-600',
          activeStep: 'bg-emerald-600 border-emerald-600',
          inactiveStep: 'bg-white border-emerald-200',
          activeText: 'text-emerald-600',
          activeIcon: 'text-white'
        };
      default:
        return {
          line: 'bg-gray-200',
          activeLine: 'bg-primary',
          activeStep: 'bg-primary border-primary',
          inactiveStep: 'bg-white border-gray-200',
          activeText: 'text-primary',
          activeIcon: 'text-white'
        };
    }
  };

  const themeClasses = getThemeClasses();

  return (
    <div className="relative">
      {/* Timeline Line */}
      <div className="absolute left-8 top-12 bottom-0 w-0.5 bg-gray-200">
        <div className={`w-full h-1/2 ${themeClasses?.activeLine}`} />
      </div>
      {/* Steps */}
      <div className="space-y-8">
        {steps?.map((step, index) => {
          const isActive = index <= Math.floor(steps?.length / 2);
          
          return (
            <div key={index} className="relative flex items-start gap-6">
              {/* Step Circle */}
              <div className={`relative z-10 w-16 h-16 rounded-full border-2 flex items-center justify-center ${
                isActive ? themeClasses?.activeStep : themeClasses?.inactiveStep
              }`}>
                <Icon 
                  name={step?.icon} 
                  size={24} 
                  className={isActive ? themeClasses?.activeIcon : 'text-gray-400'} 
                />
              </div>
              {/* Content */}
              <div className="flex-1 pb-8">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className={`text-lg font-semibold ${
                    isActive ? themeClasses?.activeText : 'text-gray-900'
                  }`}>
                    {step?.title}
                  </h3>
                  <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded">
                    {step?.duration}
                  </span>
                </div>
                
                <p className="text-gray-600 mb-4">
                  {step?.description}
                </p>

                {/* Deliverables */}
                {step?.deliverables && (
                  <div className="space-y-2">
                    <h4 className="text-sm font-medium text-gray-900">
                      Key Deliverables:
                    </h4>
                    <ul className="space-y-1">
                      {step?.deliverables?.map((deliverable, idx) => (
                        <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                          <Icon name="Check" size={14} className={themeClasses?.activeText} />
                          {deliverable}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Tools Used */}
                {step?.tools && (
                  <div className="mt-4">
                    <h4 className="text-sm font-medium text-gray-900 mb-2">
                      Tools & Equipment:
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {step?.tools?.map((tool, idx) => (
                        <span 
                          key={idx}
                          className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded"
                        >
                          {tool}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProcessTimeline;